module.exports = __webpack_public_path__ + "static/img/5.b63d6aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/sp/5.png
// module id = Jivf
// module chunks = 0